module.exports = __webpack_public_path__ + "img/52114135_L.5c5ffbf5.png";